import React from 'react';

import { Container } from './styles';

const Footer: React.FC = () => {
  return <Container>{`Versão: ${process.env.REACT_APP_VERSION}`}</Container>;
};

export default Footer;
